// EventGroupHelper.js
export const processEventsForGrouping = (events) => {
    // 按开始时间排序
    const sortedEvents = [...events].sort((a, b) => a.startTime - b.startTime);
    
    // 创建事件组
    const eventGroups = [];
    let currentGroup = [];
    
    // 遍历排序后的事件
    sortedEvents.forEach((event, index) => {
        if (currentGroup.length === 0) {
            // 开始新的事件组
            currentGroup.push(event);
        } else {
            const lastEvent = currentGroup[currentGroup.length - 1];
            
            // 检查时间重叠
            const isOverlapping = event.startTime <= lastEvent.endTime;
            
            if (isOverlapping) {
                // 添加到当前组
                currentGroup.push(event);
            } else {
                // 保存当前组并开始新组
                eventGroups.push([...currentGroup]);
                currentGroup = [event];
            }
        }
        
        // 处理最后一个事件
        if (index === sortedEvents.length - 1 && currentGroup.length > 0) {
            eventGroups.push([...currentGroup]);
        }
    });
    
    // 处理每个事件组
    const groupedEvents = eventGroups.map(group => {
        if (group.length === 1) {
            return group[0];
        }
        
        // 合并重叠事件
        const mainEvent = group[0];
        const eventNames = group.map(e => e.event).join(' | ');
        const startTime = Math.min(...group.map(e => e.startTime));
        const endTime = Math.max(...group.map(e => e.endTime));
        
        // 计算平均优先级
        const avgPriority = Math.round(
            group.reduce((sum, e) => sum + (e.priority || 3), 0) / group.length
        );
        
        // 合并其他重要信息
        const mergedEvent = {
            ...mainEvent,
            event: eventNames,
            startTime,
            endTime,
            duration: endTime - startTime,
            priority: avgPriority,
            groupedEvents: group,
            isGrouped: true,
            // 添加合并事件的元数据
            metadata: {
                originalCount: group.length,
                timeRange: `${formatTime(startTime)} - ${formatTime(endTime)}`,
                eventTypes: [...new Set(group.map(e => e.type))],
                confidenceLevels: [...new Set(group.map(e => e.confidence))]
            }
        };
        
        return mergedEvent;
    });
    
    return groupedEvents;
};

// 辅助函数：格式化时间
const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const getConfidenceColor = (probability) => {
    if (typeof probability === 'string') {
        return '#fff';
    } else if (typeof probability === 'number') {
     
        return '#93c5fd';
    }
    return '#6b7280';
};